import { loaderCreator } from '@/vuex/plugins/loaderPlugin/_base'
import * as cookieScript from '@/utils/cookieConsent'

function _loadCookieScript() {
  const consent = cookieScript.getConsentFromCookie()
  if (!consent?.action) {
    cookieScript.initThirdPartyScripts(cookieScript.ALL_CONSENTS)
    return
  }

  cookieScript.init()
}

export default loaderCreator(_loadCookieScript)
